import {
  DEFAULT_HEATMAP_COLORS,
  CSAT_COLOR_MAPPINGS,
  CSAT_METRICS,
} from '@/features/report-snapshots/constants';
import type { ChartDefinition } from '@/features/report-snapshots/api/schema';

export function buildHeatmapColors(chartDefinition: ChartDefinition): [number, string][] {
  const metricId = chartDefinition.chartSeries[0]?.metricId;

  if (!metricId) {
    return DEFAULT_HEATMAP_COLORS;
  }

  return CSAT_METRICS.includes(metricId) ? CSAT_COLOR_MAPPINGS : DEFAULT_HEATMAP_COLORS;
}

export function getHeatmapColorStops(chartDefinition: ChartDefinition): [number, string][] {
  return buildHeatmapColors(chartDefinition);
}
